// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"161d1c79","513":"1546b520","787":"c67e12cf"}[chunkId] + ".chunk.js";
};